export const cubeApiUrl = process.env.ANALYTICS_ENDPOINT;
export const ephemeralCubeApiUrl = process.env.ANALYTICS_ENDPOINT_EPHEMERAL;
// In production studio_env, ANALYTICS_ENDPOINT (analytics.medable.com) is not a
// usable analytics host. The real hosts are analytics-eu1 (prod data) and
// analytics-eu1-dev (test data). Any direct Cube API call must resolve through
// here rather than using cubeApiUrl raw, otherwise it 404s/errors in prod.
const PROD_CUBE_API_URL = 'https://analytics-eu1.medable.com/cubejs-api/v1';
const PROD_TEST_CUBE_API_URL = 'https://analytics-eu1-dev.medable.com/cubejs-api/v1';
export const resolveCubeApiUrl = ({ env, activeReportsTab, isEphemeral, }) => {
    if (isEphemeral) {
        return ephemeralCubeApiUrl;
    }
    if (process.env.STUDIO_ENV !== 'production') {
        return cubeApiUrl;
    }
    if (env === 'test' || activeReportsTab === 0) {
        return PROD_TEST_CUBE_API_URL;
    }
    if (env === 'prod' || activeReportsTab === 1) {
        return PROD_CUBE_API_URL;
    }
    return cubeApiUrl;
};
// TODO: remove once md_idtoken setup is done from BE
export const cubeApiToken = 'eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCIsImtpZCI6MTcyMDQ0NDc1MjA0OSwidHlwZSI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2FwaS1pbnQtZGV2Lm1lZGFibGUuY29tL2dzazIxODEzMC1waWxvdC1kZXYvdjIiLCJpc3MiOiJkWjNVdXQzb2dhaU14cGJmRzJkWE12IiwiaWF0IjoxNzM3MzkzMzA4LCJjb3J0ZXgvc2NwIjpbIioiXSwianRpIjoiNjc4ZTg0OWM3ZWJmNDBiODUwNmRjNWM1Iiwic3ViIjoiNjcwNjcyM2ZhYTU1ZTFmZjBlNzJlNGQ4IiwiY29ydGV4L2VtbCI6InNpdmEuY2hhaXRhbnlhQG1lZGFibGUuY29tIn0.J_9ekVG6EE6676CgDXvlAa0gVC5tATHf5dt2FsSUFNM6gquCMYbDaS4zrjhXQ46bSnSNB-9eIRh84yK_Uzibl0sZEub-f58wx6z-fRApMLqHe2B-EqrzbVhMElK3XNt2k-qsdPHTzEpCmf4WAjr4ndFxiVG0IfUk0N5ce_rLPPc1U6tgZc4IwzoC-8BjIaXUDUlP2nxRxRaBG2_rCut5J7XYDZuDEDtYiQup8V86RGbsUpjsEs5Ej50YiZOAMrLrjlIcyfcNaSZuKjYDZTs3NqPEnfAR-KrQfvRHhDHWElLukg2EI1LsAfQlGKLKpRIvuUzTrJh-ldndGWkZUGetqQ';
